import { Component, OnInit,  } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";
import { champerTemperatureStatuses } from "@shared/constants/champerTemperatureStatuses";
import { MaterialsComparer } from "@shared/helpers/materials-comparer";
import { IPrintFileModal } from "@shared/interfaces/file/print-file-modal";
import { AlertService } from "@shared/services/alert.service";
import { ApiService } from "@shared/services/api.service";
import { StorageService } from "@shared/services/storage.service";

@Component({
  selector: 'app-confirm-printing-file-modal',
  templateUrl: './confirm-printing-file-modal.component.html',
  styleUrls: ['./confirm-printing-file-modal.component.scss']
})
export class ConfirmPrintingFileModalComponent implements OnInit {
  modalData!: IPrintFileModal;
  loading: boolean = false;
  differentMaterials = true;
  chamberTemperatureNotStabilized = false;
  isChecked = false;
  noMainMaterialLoaded: boolean = false;

  constructor(
    private api: ApiService,
    private alertService: AlertService,
    protected dialogRef: NbDialogRef<ConfirmPrintingFileModalComponent>,
    private storage: StorageService) {
  }

  ngOnInit() {
    const loadedMaterials = this.modalData.device.status.currentLoadedMaterials;
    if (loadedMaterials.length === 0 || loadedMaterials[0].name.includes("NO MATERIAL")) {
      this.noMainMaterialLoaded = true;
      return;
    }

    if (this.modalData.file.materials.length > 0) {
      this.differentMaterials = !MaterialsComparer.equals(loadedMaterials.map(({ id }) => id), this.modalData.file.materials.map(({ id }) => id));
    }

    this.chamberTemperatureNotStabilized = this.modalData.device.status.chamber.temperatureStatus !== champerTemperatureStatuses.STABILIZED
  }

  private printFileNoMemory(): void {
    this.api.postStartMultiPrint(this.modalData.file.id, [ this.modalData.device.id ])
      .subscribe({
        next: () => {
          this.loading = false;
          this.alertService.success('commands.start-printing-success');
          this.dialogRef.close();
        },
        error: () => {
          this.loading = false;
          this.dialogRef.close();
        }
      });
  }

  private printFileWithMemory(): void {    
    this.api.postStartPrinting(this.modalData.device.id, this.modalData.file.path)
      .subscribe({
        next: () => {
          this.loading = false;
          this.alertService.success('commands.start-printing-success');
          this.dialogRef.close();

          this.storage.setSessionStorage(StorageService.parsingFileName(this.modalData.device.id), this.modalData.file.name);
        },
        error: err => {
          this.loading = false;
          this.dialogRef.close();
        }
      });
  }

  protected printFile(): void {
    this.loading = true;

    if (this.modalData.noMemory) {
      this.printFileNoMemory();
      return;
    }

    this.printFileWithMemory();
  }

  confirmPrint(checked: boolean): void {
    this.isChecked = checked;
  }

  close(): void {
    this.dialogRef.close();
  }
}
